import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import ServicesIndex from "@/pages/ServicesIndex";
import ServicePage from "@/pages/ServicePage";
import CitiesIndex from "@/pages/CitiesIndex";
import CityPage from "@/pages/CityPage";
import ComboPage from "@/pages/ComboPage";
import ContactPage from "@/pages/ContactPage";
import GuidesIndex from "@/pages/GuidesIndex";
import ArticlePage from "@/pages/ArticlePage";
import CareersPage from "@/pages/CareersPage";
import AdminGuides from "@/pages/AdminGuides";
import LegacyRedirect from "@/pages/LegacyRedirect";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout lang="en" />}>
            <Route index element={<Home lang="en" />} />
            <Route path="security-services" element={<ServicesIndex lang="en" />} />
            <Route path="security-services/:serviceSlug" element={<ServicePage lang="en" />} />
            <Route path="security-services/:serviceSlug/:citySlug" element={<ComboPage lang="en" />} />
            <Route path="quebec-locations" element={<CitiesIndex lang="en" />} />
            <Route path="quebec-locations/:citySlug" element={<CityPage lang="en" />} />
            <Route path="guides" element={<GuidesIndex lang="en" />} />
            <Route path="guides/:articleSlug" element={<ArticlePage lang="en" />} />
            <Route path="careers" element={<CareersPage lang="en" />} />
            <Route path="contact" element={<ContactPage lang="en" />} />
            <Route path="admin/guides" element={<AdminGuides />} />
            {/* Legacy 1stnation-security.com URLs → closest new page */}
            <Route path="services/:svc" element={<LegacyRedirect kind="service" lang="en" />} />
            <Route path="services/:svc/:city" element={<LegacyRedirect kind="combo" lang="en" />} />
            <Route path="locations/:prov/:city" element={<LegacyRedirect kind="city" lang="en" />} />
            <Route path="sectors/:x" element={<Navigate to="/" replace />} />
            <Route path="insights/:x" element={<Navigate to="/guides" replace />} />
          </Route>
          <Route path="/fr" element={<Layout lang="fr" />}>
            <Route index element={<Home lang="fr" />} />
            <Route path="services-de-securite" element={<ServicesIndex lang="fr" />} />
            <Route path="services-de-securite/:serviceSlug" element={<ServicePage lang="fr" />} />
            <Route path="services-de-securite/:serviceSlug/:citySlug" element={<ComboPage lang="fr" />} />
            <Route path="villes-quebec" element={<CitiesIndex lang="fr" />} />
            <Route path="villes-quebec/:citySlug" element={<CityPage lang="fr" />} />
            <Route path="guides" element={<GuidesIndex lang="fr" />} />
            <Route path="guides/:articleSlug" element={<ArticlePage lang="fr" />} />
            <Route path="carrieres" element={<CareersPage lang="fr" />} />
            <Route path="contact" element={<ContactPage lang="fr" />} />
            {/* Legacy French URLs */}
            <Route path="services/:svc" element={<LegacyRedirect kind="service" lang="fr" />} />
            <Route path="services/:svc/:city" element={<LegacyRedirect kind="combo" lang="fr" />} />
            <Route path="quebec/:city" element={<LegacyRedirect kind="city" lang="fr" />} />
            <Route path="sectors/:x" element={<Navigate to="/fr" replace />} />
            <Route path="insights/:x" element={<Navigate to="/fr/guides" replace />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
